/**
 * Parse error or valid message from initiateIdentityValidation response to return to vsb merchant
 * @param {object} response sdk initiateIdentityValidation response
 * @returns {object} Response object for vsb merchant
 */
import { MA, MASTERCARD } from '../constants/partnering-networks';
import isEmptyString from './is-empty-string';
import OrchCustomData from './orch-custom-data';

const filterVsbInitiateIdentityValueResponse = response => {
  const preferredNetwork = OrchCustomData.srcSdks.orchConfig.preferredNetwork;
  /*
  * We need this const duplicated from api-error-enums.js here in the vsb orch layer to send the err message
  * when MA sends us an error response without the error code. Currently in some error use cases,
  * MA is sending us { error: undefined }
  */
  const OTP_SEND_FAILED = 'OTP_SEND_FAILED';

  if (response?.error?.reason) {
    return { error: { reason: response.error.reason } };
  } else if (isEmptyString(response?.maskedValidationChannel)) {
    return { error: { reason: OTP_SEND_FAILED } };
  }
  return {
    maskedValidationChannel:
      response.maskedValidationChannel === MA ? MASTERCARD : response.maskedValidationChannel,
    otpProvider: preferredNetwork === MA ? MASTERCARD : preferredNetwork
  };
};

export default filterVsbInitiateIdentityValueResponse;
